import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import translate from '@noar-basf/commons';
import { useSelector } from 'react-redux';
import Policy from '.';

import './Styles.scss';
import Br from './br';
import En from './en';
import Es from './es';

export default function PrivacyPolicyPage() {
  const locale = useSelector(({ i18n }) => i18n.lang);
  const { search } = useLocation();
  let PolicyLanguage = Br;

  const [lang, setLang] = useState(locale);
  const langRegex = /^\?lang=([a-z]{2})/;

  useEffect(() => {
    if (langRegex.test(search)) {
      setLang(langRegex.exec(search)[1]);
    }
  }, []);

  const Privacy = () => {
    if (lang === 'en') {
      PolicyLanguage = En;
    } else if (lang === 'es') {
      PolicyLanguage = Es;
    }

    return <Policy Language={PolicyLanguage} />;
  };

  window.setPageTitle(translate(locale).defaultMessages?.privacyPolicy);
  return <Privacy />;
}
